// Highlight each step number as it scrolls into view

const steps = document.querySelectorAll('.how-it-works__step');

if (steps.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-active');
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.4 }
    );

    steps.forEach((step, i) => {
        step.style.transitionDelay = `${i * 100}ms`;
        observer.observe(step);
    });
}
